import React from "react";
import ReactSelect from "react-select";
import "@/assets/react-select-theme.css";

const Select = React.forwardRef((props, ref) => {
  const {
    classNamePrefix,
    className,
    unstyled,
    placeholder,
    noOptionsMessage,
    loadingMessage,
    ...rest
  } = props;

  return (
    <ReactSelect
      ref={ref}
      unstyled={unstyled ?? true}
      classNamePrefix={classNamePrefix ?? "react-select"}
      className={`react-select-container ${className ?? ""}`.trim()}
      placeholder={placeholder ?? ""}
      noOptionsMessage={noOptionsMessage ?? (() => "لا توجد خيارات")}
      loadingMessage={loadingMessage ?? (() => "جاري التحميل...")}
      {...rest}
    />
  );
});

Select.displayName = "Select";

export default Select;
